import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import BDetailsPage from "../../../components/crud/BDetailsPage";
import BErrorIndicator from "../../../components/indicators/BErrorIndicator";
import BLoadingIndicator from "../../../components/indicators/BLoadingIndicator";
import { maklersService } from "../../../service/maklersService";

const MaklersDetails = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [makler, setMakler] = useState(null);
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    setIsLoading(true);
    setError(false);
    maklersService
      .getMaklerById(id)
      .then((res) => {
        setMakler(parseBrokerObjectsToStrings(res.data))
      }) 
      .catch((err) => {
        if (!err.response || err.response.status === 404) {
          history.push("/brokers");
        }
        setError(true);
      })
      .finally((_) => {
        setIsLoading(false);
      });
  }, [id]);

  const parseBrokerObjectsToStrings = (broker) => {
    broker.regions = broker.regions ? broker.regions.map((el) => el.name).join(", ") : "";
    delete broker.regionsPlaces;
    broker.zipCodes = broker.zipCodes ? broker.zipCodes.join(", ") : "";
    if (broker != null && broker.districts != null && broker.districts.length > 0) {
      broker.districts = broker.districts.map(x => x.name).join(", ");
    }
    return broker;
  };

  const handleDelete = () => {
    maklersService.deleteMakler(id).then(() => {
      history.push("/brokers");
    });
  };

  const handleActivate = () => {
    maklersService.activateMakler(id).then(() => {
      history.push("/brokers");
    });
  };

  const handleDeactivate = () => {
    maklersService.deactivateMakler(id).then(() => {
      history.push("/brokers");
    });
  };

  const handleBlock = () => {
    maklersService.blockMakler(id).then(() => {
      history.push("/brokers");
    });
  };

  const handleUnblock = () => {
    maklersService.unblockMakler(id).then(() => {
      history.push("/brokers");
    });
  };

  if (isLoading) {
    return <BLoadingIndicator />;
  } else if (error) {
    return <BErrorIndicator />;
  }

  return (
    <BDetailsPage
      data={makler}
      handleDelete={handleDelete}
      handleActivate={handleActivate}
      handleDeactivate={handleDeactivate}
      handleBlock={handleBlock}
      handleUnblock={handleUnblock}
      isActive={makler?.isActive}
      isBlocked={makler?.isBlocked}
      isBroker={true}
    />
  );
};

export default MaklersDetails;
